import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Om Shrestha</span>
            from <span className="purple"> Bargarh,Odisha .</span>
            <br />
            <br/>
            Hey there! I'm Om Shrestha, a passionate coder on a journey of continuous learning and growth. 🌱 With a solid foundation in Full Stack Web Development from Masai - Learning, I'm always eager to explore the ever-evolving world of technology.
            <br />
           
            <br />
            <br />
           
          </p>
          

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Om</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
